/* By Carola Kassen-Fenster, Teil 1: Daten und Vorschlagslogik (Runde 11, 20.10.2026).
   Nachbau des Sunnafrucht-Kassen-Pop-ups (16.10.2026) für das Theme Stiletto.
   Vorschläge: Querverweise der Stücke im Warenkorb (erst „Passt perfekt dazu“, dann „Diese Stücke passen dazu“),
   abwechselnd je Stück, aufgefüllt mit den Bestsellern der Ersatz-Kollektion. Die Variante richtet sich nach dem
   Stück im Warenkorb (gleiche Farbe, Steinfarbe, Kettenlänge, sonst die erste lieferbare).
   Daten live aus /products/<handle>?section_id=bc-kassen-feed und
   /collections/<handle>?sort_by=best-selling&section_id=bc-kassen-feed (sections/bc-kassen-feed.liquid).
   Einstellungen: Theme-Editor > Footer > Kassen-Fenster (sections/bc-kassen-fenster.liquid). */
(function () {
  'use strict';
  if (window.BCKF && window.BCKF.fn) return;
  var BCKF = window.BCKF = { feeds: {}, st: {}, root: null, origin: null, passing: false, busy: false, hideTimer: 0 };
  var R = BCKF.R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'bckf_seen_v1';
  var FEED = 'bc-kassen-feed';

  function cfg() {
    var el = document.getElementById('bckf-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function rate() {
    var r = window.Shopify && window.Shopify.currency ? Number(window.Shopify.currency.rate) : 1;
    return r > 0 ? r : 1;
  }
  function design() { return !!(window.Shopify && window.Shopify.designMode); }
  function seen() { try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function decode(s) { var t = document.createElement('textarea'); t.innerHTML = String(s); return t.value; }
  function plain(s) { var d = document.createElement('div'); d.innerHTML = String(s); return d.textContent || ''; }
  function dl(cents, prec, th, dec) {
    var n = (cents / 100).toFixed(prec).split('.');
    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (n[1] ? dec + n[1] : '');
  }
  /* Runde 15: Beträge ohne Sternchen in der Währung des Besuchers (window.bcMoney aus snippets/theme-setup.liquid, sonst Intl).
     Ersatz wie formatMoney im Theme (assets/theme.js) mit dem Geldformat des Shops, ohne Sternchen. */
  function fmt(cents) {
    cents = Math.round(Number(cents) || 0);
    if (typeof window.bcMoney === 'function') return window.bcMoney(cents);
    var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (cur) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) {}
    }
    var c = cfg() || {};
    var f = c.moneyFormat || (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var m = String(f).match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return dl(cents, 2, '.', ',');  /* ohne Platzhalter: nur die Zahl */
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = dl(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = dl(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = dl(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = dl(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = dl(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': v = dl(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = dl(cents, 2, ' ', '.'); break;
      default: v = dl(cents, 2, ',', '.');
    }
    return decode(String(f).replace(m[0], function () { return v; }).replace(/<[^>]*>/g, '')).replace(/\*/g, '').trim();
  }
  function getCart() {
    return fetch(R + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function load(url) {
    var F = BCKF.feeds;
    if (!F[url]) {
      F[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('feed'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var s = doc.querySelector('script[data-bckf-feed]');
          var list = s ? JSON.parse(s.textContent) : [];
          return Array.isArray(list) ? list : [];
        })
        .catch(function () { delete F[url]; return []; });
    }
    return F[url];
  }
  function feedProduct(h) { return load(R + 'products/' + encodeURIComponent(h) + '?section_id=' + FEED); }
  function feedCollection(h) { return load(R + 'collections/' + encodeURIComponent(h) + '?sort_by=best-selling&section_id=' + FEED); }
  function opts(item) {
    var o = {};
    (item.options_with_values || []).forEach(function (x) { if (x && x.name) o[x.name] = x.value; });
    return o;
  }
  /* Eine Regel mit allen Stücken im Warenkorb (je Stück eine Liste, abwechselnd), danach die Ersatz-Kollektion */
  function plan(c, cart) {
    var inCart = {}, sources = [], seenP = {};
    (cart.items || []).forEach(function (i) {
      inCart[i.product_id] = true;
      if (!seenP[i.product_id] && i.handle) {
        seenP[i.product_id] = true;
        sources.push({ id: i.product_id, h: i.handle, title: i.product_title || i.title || '', opts: opts(i) });
      }
    });
    var chain = [];
    if (sources.length) chain.push({ kind: 'refs', targets: sources.map(function (s) { return { h: s.h, src: s }; }) });
    if (c.fallback) chain.push({ kind: 'fallback', coll: true, targets: [{ h: c.fallback, src: sources[0] || null }] });
    return { chain: chain, inCart: inCart, sources: sources };
  }
  function label(v) {
    return (v.o || []).filter(function (x) { return x && x !== 'Default Title'; }).join(' · ');
  }
  /* Lieferbare Variante mit den meisten gleichen Optionen wie das Stück im Warenkorb, bei Gleichstand die erste */
  function pick(p, src, cap) {
    var best = null, bestScore = -1;
    (p.vs || []).forEach(function (v) {
      if (!v || v.a !== true || (cap && v.p > cap)) return;
      var score = 0;
      if (src && src.opts) {
        (p.on || []).forEach(function (name, i) {
          if (src.opts[name] !== undefined && (v.o || [])[i] === src.opts[name]) score++;
        });
      }
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }
  function choose(c, pl, lists) {
    var max = Number(c.max) || 8;
    var cap = c.maxPrice ? Math.round(c.maxPrice * rate()) : 0;
    var out = [], taken = {}, head = null;
    pl.chain.forEach(function (rule, ri) {
      if (out.length >= max) return;
      var before = out.length;
      var queues = (rule.targets || []).map(function (t, ti) {
        return ((lists[ri] || [])[ti] || []).map(function (p) {
          if (!p || p.a !== true || pl.inCart[p.id]) return null;
          var v = pick(p, t.src, cap);
          return v ? { id: p.id, h: p.h, t: p.t, img: p.img, v: v.id, p: v.p, pf: fmt(v.p), label: label(v) } : null;
        }).filter(Boolean);
      });
      var moved = true;
      while (out.length < max && moved) {
        moved = false;
        for (var q = 0; q < queues.length && out.length < max; q++) {
          while (queues[q].length) {
            var it = queues[q].shift();
            if (!taken[it.id]) { taken[it.id] = true; out.push(it); moved = true; break; }
          }
        }
      }
      if (!head && out.length > before) head = rule;
    });
    return { items: out, head: head, sources: pl.sources };
  }
  function feeds(pl) {
    return Promise.all(pl.chain.map(function (r) {
      return Promise.all((r.targets || []).map(function (t) { return r.coll ? feedCollection(t.h) : feedProduct(t.h); }));
    }));
  }
  function resolve(c, preview) {
    return getCart().then(function (cart) {
      if (!preview && !cart.item_count) return null;
      var pl = plan(c, cart);
      return feeds(pl).then(function (lists) {
        var res = choose(c, pl, lists);
        res.cart = cart;
        return res.items.length ? res : null;
      });
    });
  }
  function prefetch(c) {
    return getCart().then(function (cart) {
      if (cart.item_count) feeds(plan(c, cart));
    }).catch(function () {});
  }

  BCKF.fn = { cfg: cfg, rate: rate, design: design, seen: seen, markSeen: markSeen, plain: plain, fmt: fmt, getCart: getCart, feedProduct: feedProduct, feedCollection: feedCollection, plan: plan, pick: pick, label: label, choose: choose, resolve: resolve, prefetch: prefetch };
})();
